import { call, put, takeEvery } from 'redux-saga/effects';
import { requestApi2 } from '../../../../lib/request';
import showAlertSaga from '../../../../utilities/alert';
import { showLoading } from '../loading';
import {
  postServiceProductOrderFail,
  postServiceProductOrderSuccess,
  putServiceProductOrderFail,
  putServiceProductOrderSuccess,
} from './actions';
import { constants, services } from './config';

function* postServiceProductOrderWorker(action) {
  try {
    yield put(showLoading(true));
    const response = yield call(requestApi2, services.postServiceProductOrder(action.payload), [
      'version',
    ]);
    if (response && response.status >= 200 && response.status < 300) {
      let res = [];
      if (
        response.data.order.order_status === 'preparing' ||
        response.data.order.order_status === 'order_received' ||
        response.data.order.order_status === 'pending'
      ) {
        res = response.data.order;
        res.status = 'success';
        res.serviceSlug = action.payload.serviceSlug;
        res.client_secret = null;
      } else if (response.data.order.order_status === 'not_paid') {
        res.id = response.data.order.uuid;
        res.status = 'requires_action';
        res.client_secret = response.data.payment_intent.client_secret;
        res.payment_intent = response.data.payment_intent;
      }
      yield put(showLoading(false));
      yield put(postServiceProductOrderSuccess(res));
    } else {
      yield put(showLoading(false));
      throw response;
    }
  } catch (error) {
    yield put(postServiceProductOrderFail(error));
    yield put(showLoading(false));
    yield showAlertSaga({
      error: error.status,
      color: 'red',
      message: window.intl.formatMessage({
        id: error?.message || 'error.generic',
      }),
    });
  }
}

function* putServiceProductOrderWorker(action) {
  try {
    const response = yield call(requestApi2, services.putServiceProductOrder(action.payload), [
      'version',
    ]);
    if (response && response.status >= 200 && response.status < 300) {
      let res = [];
      res = response.data;
      res.status = 'success';
      yield put(putServiceProductOrderSuccess(res));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(putServiceProductOrderFail(error));
    yield showAlertSaga({
      error: error.status,
      color: 'red',
      message: window.intl.formatMessage({
        id: error?.message || 'error.generic',
      }),
    });
  }
}

export default function* serviceProductOrderSaga() {
  yield takeEvery(constants.POST_SERVICE_PRODUCT_ORDER, postServiceProductOrderWorker);
  yield takeEvery(constants.PUT_SERVICE_PRODUCT_ORDER, putServiceProductOrderWorker);
}
